/* istanbul ignore file */

import { DialogModel } from '../../models';

export const NO_REORDER_ROWS_WHILE_SORTED_DIALOG_CONSTANTS: DialogModel = {
    title: 'Action Disabled',
    message: 'Row reordering is disabled while the grid is in sorted view. <br /> <br /> Would you like to remove sorting?',
    confirmationActionTitle: 'Yes',
    dataRow: '',
    customValue: '',
    appId: '',
    projId: '',
    projectName: '',
    id: ''
};

export const NO_REORDER_ROWS_WHILE_SORTED_OR_FILTERED_DIALOG_CONSTANTS: DialogModel = {
    title: 'Action Disabled',
    message: 'Row reordering is disabled while the grid is in sorted or filtered view. <br /> <br /> Would you like to remove sorting and filtering?',
    confirmationActionTitle: 'Yes',
    dataRow: '',
    customValue: '',
    appId: '',
    projId: '',
    projectName: '',
    id: ''
};
